import i18next from 'i18next';
import { ProductAbbreviation } from '../../../../../types/product';

export const getPromoRewardMessageByGame = (productAbbreviation: string, t: i18next.TFunction) => {
  switch (productAbbreviation) {
    case ProductAbbreviation.LOL:
      return t('Get a free champion skin');
    case ProductAbbreviation.TFT:
      return t('Get a free random Little Legend');
    default:
      return null;
  }
};
